export default __webpack_public_path__ + "static/media/profile-pic.3cb2787c.svg";